import { useStoreContact } from "@/context/StoreContactContext";
import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { BRAND } from "@/lib/data";

export default function Terms() {
  const contact = useStoreContact();
  return (
    <LegalLayout title="Terms & Conditions" updated="August 2026">
      <p className="text-lg text-foreground leading-relaxed" data-testid="terms-intro">
        Welcome to {BRAND.name}. By visiting our store, using our website, or placing an order with us,
        you agree to the following terms and conditions. Please read them carefully.
      </p>

      <LegalSection n="01" title="About Us">
        <p>
          {BRAND.name} is a neighbourhood super market serving customers in {BRAND.locality} since {BRAND.established}.
          We offer daily groceries, fresh produce, dairy, beverages, personal care, household essentials, and local home delivery.
        </p>
      </LegalSection>

      <LegalSection n="02" title="Products, Availability & Pricing">
        <p>
          All products are subject to availability. We try our best to keep our shelves stocked, but some items may
          run out. Prices are set fairly and may change from time to time without prior notice due to market conditions.
          The price applicable is the one in effect at the time of your purchase or order confirmation.
        </p>
      </LegalSection>

      <LegalSection n="03" title="Orders & Home Delivery">
        <p>
          We offer local home delivery within and around Dabok, Udaipur. To place an order, call us or send your list
          through our contact form. Delivery timing depends on your location and order volume, and is available during
          our store hours. We reserve the right to accept or decline any order.
        </p>
      </LegalSection>

      <LegalSection n="04" title="Payments">
        <p>We accept the following payment methods:</p>
        <ul className="list-disc pl-5 space-y-2">
          {BRAND.payments.map((p) => (
            <li key={p}>{p}</li>
          ))}
        </ul>
        <p>Please ensure payment is completed as agreed at the time of purchase or delivery.</p>
      </LegalSection>

      <LegalSection n="05" title="Returns, Exchanges & Refunds">
        <p>
          Perishable goods (such as fresh fruits, vegetables, and dairy) cannot be returned once delivered, unless
          they are damaged or spoiled at the time of delivery — in which case, please report it to us
          <strong className="text-foreground"> within 24 hours</strong>. For packaged and non-perishable items, you may
          request a return or exchange <strong className="text-foreground">within 7 days</strong> of purchase, provided
          the item is unused, in its original packaging, and accompanied by a valid proof of purchase. Approved returns
          will be exchanged or refunded within <strong className="text-foreground">5–7 working days</strong> at our discretion.
        </p>
      </LegalSection>

      <LegalSection n="06" title="Store Hours">
        <p>Our store is {BRAND.hours}. Delivery and support are available during these hours.</p>
      </LegalSection>

      <LegalSection n="07" title="Use of Our Website">
        <p>
          You agree to use our website only for lawful purposes and not to misuse it in any way. Content, images, and
          the {BRAND.name} name and logo are our property and may not be copied or used without our permission.
        </p>
      </LegalSection>

      <LegalSection n="08" title="Limitation of Liability">
        <p>
          {BRAND.name} will not be liable for any indirect or incidental loss arising from the use of our products,
          website, or delivery service, beyond the value of the goods purchased. Nothing in these terms limits your
          rights under applicable consumer law.
        </p>
      </LegalSection>

      <LegalSection n="09" title="Governing Law">
        <p>
          These terms are governed by the laws of India. Any disputes shall be subject to the jurisdiction of the
          courts in Udaipur, Rajasthan.
        </p>
      </LegalSection>

      <LegalSection n="10" title="Contact Us">
        <p>For any questions about these terms, please contact us:</p>
        <ul className="space-y-1">
          <li><strong className="text-foreground">{BRAND.name}</strong></li>
          <li>{BRAND.address}</li>
          {contact.phone && <li>Phone: <a href={contact.phoneHref} className="text-accent hover:underline">{contact.phone}</a></li>}
          {contact.email && <li>Email: <a href={`mailto:${contact.email}`} className="text-accent hover:underline">{contact.email}</a></li>}
        </ul>
      </LegalSection>
    </LegalLayout>
  );
}
